import React from 'react';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import InputAdornment from '@mui/material/InputAdornment';
import SearchRoundedIcon from '@mui/icons-material/SearchRounded';

type AdminSearchBarProps = {
  searchTerm: string;
  handleChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
};

export const AdminSearchBar = ({
  searchTerm,
  handleChange,
}: AdminSearchBarProps) => {
  return (
    <Box sx={{ width: '60%', maxWidth: 360 }}>
      <TextField
        fullWidth
        size='small'
        placeholder='Search'
        value={searchTerm}
        onChange={handleChange}
        InputProps={{
          startAdornment: (
            <InputAdornment position='start'>
              <SearchRoundedIcon sx={{ fontSize: 20, color: 'text.secondary' }} />
            </InputAdornment>
          ),
          sx: {
            borderRadius: '6px',
            fontSize: '0.875rem',
            bgcolor: 'background.paper',
            '& fieldset': {
              borderColor: 'divider',
            },
            '&:hover fieldset': {
              borderColor: 'action.active',
            },
            '&.Mui-focused fieldset': {
              borderColor: 'primary.main',
            },
          },
        }}
      />
    </Box>
  );
};
